import { useContext, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { createDailyPost, getDailyPosts } from "../CommonFunc";
import "./AddPost.scss";
import { AppContext } from "../../Context/AppContext";
function AddPost(props) {
	const { theme } = useContext(AppContext);
	const [dateOffset, setDateOffset] = useState(0);
	const inputRef = useRef();
	const headerRef = useRef();
	const createPost = () => {
		createDailyPost(
			"",
			props.currentDiary.ID,
			headerRef.current.value,
			inputRef.current.value,
			dateOffset
		).then((result) => {
			getDailyPosts(props.currentDiary.ID, 0, 10).then((posts) =>
				props.setCurrentDiaryPosts(posts)
			);
		});
		props.setOpenAddPost(false);
		props.setSelectedPost(null);
	};
	const offsetUpdate = (offset) => {
		setDateOffset((prev) => prev + offset);
	};
	const formatedDate = (date) => {
		const yyyy = date.getFullYear();
		let mm = (date.getMonth() + 1).toString().padStart(2, "0"); // Months start at 0!
		let dd = date.getDate().toString().padStart(2, "0");
		const formated = dd + "." + mm + "." + yyyy;
		return formated;
	};
	let curr = new Date();
	curr.setDate(curr.getDate() + dateOffset);
	let date = curr.toISOString().substring(0, 10);
	let rus = formatedDate(curr);

	return createPortal(
		<div
			className='add-post-dialog-wrapper'
			color={theme.color}
			style={{
				fontSize: `${18 * theme.fontMultiplier}px`,
			}}
		>
			<div className='add-post-dialog'>
				<div className='content-wrapper'>
					<div className='button-block'>
						<div className='row'>
							<div
								className='close-button'
								onClick={() => props.setOpenAddPost(false)}
							>
								Закрыть
							</div>
							<div className='create-button' onClick={() => createPost()}>
								Добавить
							</div>
						</div>
					</div>
					<div className='row'>
						<label>Тема:</label>
						<input
							ref={headerRef}
							className='header-field'
							type='text'
							defaultValue={""}
							autoFocus
						/>
					</div>
					<hr style={{ width: "100%", margin: "0px 0px" }} />
					<div className='row'>
						<label>Дата:</label>
						<div className='date-picker'>
							<div
								className='date-picker-button'
								onClick={() => offsetUpdate(-1)}
							>
								{"<"}
							</div>
							<input
								className='date-picker-input'
								type='date'
								value={date}
								readOnly
							/>
							<div className='date-label'>{rus}</div>
							<div
								className='date-picker-button'
								onClick={() => offsetUpdate(1)}
							>
								{">"}
							</div>
						</div>
					</div>
					<hr style={{ width: "100%", margin: "0px 0px" }} />

					<textarea
						ref={inputRef}
						className='name-field'
						type='text'
						placeholder='Текст'
						defaultValue={""}
					/>
				</div>
			</div>
		</div>,
		document.getElementById("addPost")
	);
}

export default AddPost;
